import ROUTES from '../routes';
import Rates from '../hoc/rates/rates';
import RateList from '../hoc/rates/list';
import RateDetails from '../hoc/rates/rate-details';

const RatesRoutes = {
  path: ROUTES.RATES,
  element: <Rates />,
  children: [
    {
      path: ROUTES.RATES_CURRENCY,
      element: <RateList />,
      children: [
        {
          path: ROUTES.RATE_INFO,
          element: <RateDetails />,
        },
      ],
    },
  ],
};

export default RatesRoutes;
